import { config } from '../../Config';

const GetDistinctCategories = async () => {
    const url = config.getDistinctCategories;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch categories: ${response.statusText}`);
        }

        const data = await response.json();


        return data.categories || [];
    } catch (error) {
        // console.error('Error fetching categories:', error);
        return [];
    }
};

export default GetDistinctCategories;
